module.exports = "/_next/static/images/OptimizeTheFirstTimeUserExperience-22a5d9b8c09e4d0e13c3cead797aaedf.webp";